import React, { useState } from 'react'
import { FaAngleRight } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

function AboutSub() {

    const [abt, setabt] = useState('F')

    const handleSwitch =(value)=>{
        setabt(value)
    }

  return (
    <div className='about_sub' >
        <div className='about_sub_header'>
            <div className='about_sub_header_line'></div>
            <h2>WHAT WE DO</h2>
        </div>

        <div className='about_sub_body'>
            <div className='about_sub_body_img'></div>

            <div className='about_sub_body_writeup'>
                <div className='about_sub_body_writeup_header'>
                    <p onClick={()=>handleSwitch('F')} style={abt === 'F' ? {backgroundColor:'#da291c', color:'#fff'} : {}} >FEEDING</p>
                    <p onClick={()=>handleSwitch('H')} style={abt === 'H' ? {backgroundColor:'#da291c', color:'#fff'} : {}} >HEALTH</p>
                    <p onClick={()=>handleSwitch('S')} style={abt === 'S' ? {backgroundColor:'#da291c', color:'#fff'} : {}} >SHELTER</p>
                    <p onClick={()=>handleSwitch('E')} style={abt === 'E' ? {backgroundColor:'#da291c', color:'#fff'} : {}} >EDUCATION</p>
                </div>

                {
                    abt === 'F' ?
                        <div className='about_sub_body_writeup_body'>
                            <h3>FEEDING</h3>
                            <p>Our top priority is to ensure children and their families eat nutricious food. A simple meal can brighten someone's day and a well-fed community is a healthier and more productive one. </p>
                            <Link className='about_sub_body_writeup_body_link'>
                                <p>LEARN MORE</p>
                                <FaAngleRight/>
                            </Link>
                        </div>
                    :
                    abt === 'H' ?
                        <div className='about_sub_body_writeup_body'>
                            <h3>HEALTH</h3>
                            <p>We’re working to ensure all children have a healthy start in life. We believe that no child should die from preventable causes. </p>
                            <Link className='about_sub_body_writeup_body_link'>
                                <p>LEARN MORE</p>
                                <FaAngleRight/>
                            </Link>
                        </div>
                    :
                    abt === 'S' ?
                        <div className='about_sub_body_writeup_body'>
                            <h3>SHELTER</h3>
                            <p>Shelter is a basic human need, yet millions of less privileged individuals, including orphans, homeless families, lack a safe place to call home we help shield these people from harsh weather and dangers. Creating a sense of belonging and stability. </p>
                            <Link className='about_sub_body_writeup_body_link'>
                                <p>LEARN MORE</p>
                                <FaAngleRight/>
                            </Link>
                        </div>
                    :
                    abt === 'E' ?
                        <div className='about_sub_body_writeup_body'>
                            <h3>EDUCATION</h3>
                            <p>At The Lord Nations Foundation, we believe that education is a powerful tool that can break the cycle of poverty and transform lives. Unfortunately, many less privileged children face barriers such as financial struggles, lack of resources, and limited access to quality schools. </p>
                            <Link className='about_sub_body_writeup_body_link'>
                                <p>LEARN MORE</p>
                                <FaAngleRight/>
                            </Link>
                        </div>
                    : null
                }
            </div>
        </div>
    </div>
  )
}

export default AboutSub